import { useState } from "react";
import { login } from "../api/client.js";
import { useAppState } from "../app/AppProvider.tsx";

export function Login() {
  const state = useAppState();
  const [email, setEmail] = useState(state.userEmail || "");

  async function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const value = email.trim();
    if (!value || state.loginPending) return;
    await login(value).catch(() => {
      // Legacy client already patches loginError.
    });
  }

  return (
    <div className="hk-auth">
      <div className="hk-auth-form-side">
        <form className="hk-auth-form" onSubmit={onSubmit}>
          <div className="hk-auth-brand">
            <span className="hk-brand-mark" aria-hidden="true">
              <i className="bi bi-whatsapp" />
            </span>
            <span className="nm">CRM</span>
          </div>

          <h1>Bem-vindo de volta</h1>
          <p className="sub">Entre com seu e-mail para acessar o painel.</p>

          <label className="hk-field-label" htmlFor="login-email">E-mail</label>
          <div className="hk-field">
            <i className="bi bi-envelope" />
            <input
              id="login-email"
              type="email"
              placeholder="voce@empresa.com.br"
              value={email}
              autoComplete="email"
              required
              disabled={state.loginPending}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>

          {state.loginError ? <div className="hk-auth-error">{state.loginError}</div> : null}

          <button className="hk-auth-btn" type="submit" disabled={state.loginPending}>
            {state.loginPending ? "Entrando..." : "Entrar"}
          </button>

          <p className="hk-auth-hint">
            <i className="bi bi-shield-lock" />
            Acesso protegido por conexão segura
          </p>
        </form>
      </div>

      <div className="hk-auth-showcase">
        <div className="hk-auth-showcase-inner">
          <h2>Gerencie sua empresa inteira num só lugar.</h2>
          <ul className="hk-auth-feat">
            <li>
              <i className="bi bi-chat-dots" />
              Atendimento unificado: WhatsApp, Instagram e e-mail
            </li>
            <li>
              <i className="bi bi-robot" />
              Agentes de IA que respondem pelo seu negócio
            </li>
            <li>
              <i className="bi bi-clipboard-check" />
              Ordens de serviço com notificação automática
            </li>
            <li>
              <i className="bi bi-geo-alt" />
              A melhor rota, calculada pra você
            </li>
          </ul>
        </div>
        <div className="hk-auth-credit">Acesso restrito à equipe</div>
      </div>
    </div>
  );
}
